import { GetterTree, ActionTree, MutationTree } from 'vuex'

class State {
    historiesSearch: any[] = []
    historiesView: any[] = []
}

const getters: GetterTree<State, any> = {
    historiesSearch: (state) => state.historiesSearch,
    historiesView: (state) => state.historiesView
}

const mutations: MutationTree<State> = {
    historiesSearchMutation(state, payload) {
        state.historiesSearch = payload.reverse()
    },
    historiesViewMutation(state, payload) {
        state.historiesView = payload.reverse()
    }
}

const actions: ActionTree<State, any> = {
    historiesSearchAction({ commit }, payload) {
        let storage = []

        storage = JSON.parse(localStorage.getItem('hs') as string)

        if (payload === undefined) {
            commit('historiesSearchMutation', storage !== null ? storage : [])
        } else {
            const model = {
                country: payload.country,
                name: payload.name,
                url: payload.url
            }

            if (storage === null || storage.length === 0) {
                storage = [model]
            } else {
                const exclude = storage.filter((elem: any) => elem.url === model.url)[0]
                if (exclude === undefined) storage.push(model)
            }
            commit('historiesSearchMutation', storage)
            localStorage.setItem('hs', JSON.stringify(storage))
        }
    },
    historiesViewAction({ commit }, payload) {
        let storage = []

        storage = JSON.parse(localStorage.getItem('hv') as string)

        if (payload === undefined) {
            commit('historiesViewMutation', storage !== null ? storage : [])
        } else {
            const model = {
                country: payload.country,
                currency: payload.currency,
                image: payload.image,
                name: payload.name,
                operation: payload.operation,
                price: payload.price,
                url: payload.url
            }

            if (storage === null || storage.length === 0) {
                storage = [model]
            } else {
                const exclude = storage.filter((elem: any) => elem.url === model.url)[0]
                if (exclude === undefined) storage.push(model)
            }
            commit('historiesViewMutation', storage)
            localStorage.setItem('hv', JSON.stringify(storage))
        }
    }
}

export default {
    namespaced: true,
    state: new State(),
    mutations,
    actions,
    getters
}
